module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp13_9016.b1bb0e3a.png";